import { MapLocation } from '@/types/location';

export const alKharjDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10099,
    name: "Digital Megacom Screen – Al Kharj",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.139667, 47.276611], // Converted from 24°08'22.8"N 47°16'35.8"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/da1b010e-ff9e-4fc9-8c45-70ec6644bd13.png"
    }
  },
  {
    id: 10100,
    name: "Digital Megacom Screen – Al Kharj 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.126, 47.263222], // Converted from 24°07'33.6"N 47°15'47.6"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b3f89066-5081-4006-aeb6-2a09c19a62f6.png"
    }
  },
  {
    id: 10101,
    name: "Digital Megacom Screen – Al Kharj 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.159972, 47.311222], // Converted from 24°09'35.9"N 47°18'40.4"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/cf3942ae-a8ca-470b-b19b-ac6b43289a04.png"
    }
  },
  {
    id: 10102,
    name: "Digital Megacom Screen – Al Kharj 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.157611, 47.324556], // Converted from 24°09'27.4"N 47°19'28.4"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/074dfa8b-677b-4a9b-b755-f2c7bb08da39.png"
    }
  },
  {
    id: 10103,
    name: "Digital Megacom Screen – Al Kharj 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.163833, 47.333111], // Converted from 24°09'49.8"N 47°19'59.2"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/a014ffe0-3e00-4369-9d21-e39fe1356305.png"
    }
  },
  {
    id: 10104,
    name: "Digital Megacom Screen – Al Kharj 6",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.119833, 47.260278], // Converted from 24°07'11.4"N 47°15'39.1"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/17334fb9-4e71-4811-98b0-fe1e4abe474b.png"
    }
  },
  {
    id: 10105,
    name: "Digital Megacom Screen – Al Kharj 7",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.169750, 47.328194], // Converted from 24°10'11.1"N 47°19'41.5"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/0d983475-5a38-4550-9ac2-fc8c90e495f6.png"
    }
  },
  {
    id: 10106,
    name: "Digital Megacom Screen – Al Kharj 8",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.163028, 47.349], // Converted from 24°09'46.9"N 47°20'56.4"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/40be02a8-81ab-4687-b085-d76547fff369.png"
    }
  },
  {
    id: 10107,
    name: "Digital Megacom Screen – Al Kharj 9",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.128194, 47.263972], // Converted from 24°07'41.5"N 47°15'50.3"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b926571f-a1b4-4bb0-8aca-dc8a1ad6d3e2.png"
    }
  },
  {
    id: 10108,
    name: "Digital Megacom Screen – Al Kharj 10",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [24.164639, 47.318639], // Converted from 24°09'52.7"N 47°19'07.1"E
    region: "Al Kharj",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/8103297b-ad56-4703-a152-92366e9c8a83.png"
    }
  }
];
